import { render, staticRenderFns } from "./SocialNetworks.vue?vue&type=template&id=72ed8499&scoped=true"
import script from "./SocialNetworks.vue?vue&type=script&lang=ts"
export * from "./SocialNetworks.vue?vue&type=script&lang=ts"
import style0 from "./SocialNetworks.vue?vue&type=style&index=0&id=72ed8499&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ed8499",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VCardTitle,VImg})
